<template>
  <!-- 弹出框表单 -->
  <div class="dialog">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      :show-close="false"
      :width="dialogWidth"
      destroy-on-close
    >
      <el-form
        ref="form"
        :model="form"
        :rules="formRule"
        size="small"
        :label-width="formLabelWidth"
      >
        <el-form-item v-for="item in dialogFields" :key="item.prop" v-bind="item">
          <el-input
            v-if="item.type === 'input'"
            v-model="form[item.prop]"
            :placeholder="item.placeholder"
          ></el-input>
          <el-input
            v-if="item.type === 'textarea'"
            v-model="form[item.prop]"
            type="textarea"
            :rows="2"
            :placeholder="item.placeholder"
          ></el-input>
          <el-select
            v-if="item.type === 'select'"
            v-model="form[item.prop]"
            filterable
            :placeholder="item.placeholder"
            :multiple="item.multiple"
            @change="(val) => onSelectChange(val, item)"
          >
            <el-option
              v-for="option in item.fieldOption.options"
              :key="option[item.fieldOption.key]"
              :label="option[item.fieldOption.label]"
              :value="
                option[item.fieldOption.value] + '-' + option[item.fieldOption.label]
              "
            ></el-option>
          </el-select>
          <el-checkbox
            v-if="item.type === 'select' && item.checkboxName"
            v-model="form['checkboxValue']"
          >
            {{ item.checkboxName }}
          </el-checkbox>
          <el-cascader
            v-if="item.type === 'cascader'"
            v-model="form[item.prop]"
            :options="item.options"
            :placeholder="item.placeholder"
            :props="{ checkStrictly: true }"
          ></el-cascader>
          <UserSelect
            v-if="item.type === 'userSelect'"
            ref="UserSelect"
            :valueInput.sync="form[item.prop]"
            :placeholder.sync="item.placeholder"
          />
          <el-date-picker
            v-if="item.type === 'date'"
            style="width: 100%"
            v-model="form[item.prop]"
            type="date"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            @change="onChange(item.method, item.prop)"
          ></el-date-picker>
          <el-date-picker
            v-if="item.type === 'datetime'"
            style="width: 100%"
            v-model="form[item.prop]"
            type="datetime"
            :placeholder="item.placeholder"
            :picker-options="item.pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
          <el-date-picker
              v-if="item.type === 'datetimerange'"
              style="width: 100%"
              v-model="form[item.prop]"
              type="datetimerange"
              range-separator="至"
              :start-placeholder="item.placeholder"
              :end-placeholder="item.placeholder"
              :picker-options="item.pickerOptions"
              :default-time="item.defaultTime"
              value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UserSelect from '../../common/UserSelect'
export default {
  name: 'DrawerForm',
  components: {
    UserSelect,
  },
  props: {
    dialogFields: {
      type: Array,
      default: () => [],
    },
    formLabelWidth: {
      type: String,
      default: '',
    },
    dialogTitle: {
      type: String,
      default: '',
    },
    dialogWidth: {
      type: String,
      default: '30%',
    },
  },
  data() {
    return {
      form: {},
      formRule: {},
      dialogFormVisible: false,
    }
  },
  mounted() {
    this.dialogFields.map((obj) => {
      if (obj.require) {
        this.formRule[obj.prop] = [
          {
            required: true,
            message: '请输入' + obj.label,
            trigger:
              obj.type === 'select' ||
              obj.type === 'userSelect' ||
              obj.type === 'datetime'
                ? 'blur'
                : 'change',
          },
        ]
      }
    })
  },
  methods: {
    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.form = {}
      this.$refs.UserSelect[0].value = ''
      this.$refs.form.clearValidate()
      this.dialogFormVisible = false
    },
    onChange(method, prop) {
      if (method) {
        this.$emit(method, prop)
      }
    },
    onSelectChange(val, item) {
      // 下拉选择改变 全选变成false
      if (typeof val === 'object' && item.checkboxName) {
        if (val.length) {
          this.form.checkboxValue = false
        } else {
          this.form.checkboxValue = true
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-select {
  width: 100%;
}
</style>
